import { Component, Input, OnInit, inject } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogEvent } from "../../components/custom-controls/dynamic-dialog/dynamic-dialog.component";
import { DialogName } from "../../models/constants";

@Component({
  templateUrl: './confirm.component.html',
  styleUrl: './confirm.component.scss'
})
export class GenericConfirmComponent implements OnInit {

  @Input() header!: string;
  @Input() message!: string;

  @Input() callback!: (event: DialogEvent) => void;

  private confirmService = inject(ConfirmationService);

  ngOnInit() {
    this.confirmService.confirm({
      key: 'genericConfirm',
      header: this.header,
      message: this.message,
      accept: () => {
        this.callback({ name: DialogName.Confirm, isCompleted: true });
        return false;

      },
      reject: () => {
        this.callback({ name: DialogName.Confirm, isCompleted: false });
        this.confirmService.close();
      }
    });
  }


}




